(() => {
  if (window.clinicPrivacy) return;
  const root = document.querySelector('[data-clinic-privacy]');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const status = root.querySelector('[data-privacy-status]');
  const fields = Object.fromEntries(Array.from(root.querySelectorAll('[data-consent-purpose]')).map(input => [input.dataset.consentPurpose, input]));
  const storageKey = 'clinicagostini_maps_consent_v1';
  let apiPromise, pendingMap = null, returnFocus = null, busy = false, mapsConsent = false;
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
    mapsConsent = saved?.allowed === true && saved.expires > Date.now();
    if (saved && !mapsConsent) localStorage.removeItem(storageKey);
  } catch (_) {}
  function api() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!apiPromise) apiPromise = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error('privacy unavailable')); return; }
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (error || !window.Shopify.customerPrivacy) { reject(new Error('privacy unavailable')); return; }
        resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => { apiPromise = null; throw error; });
    return apiPromise;
  }
  function unloadMaps() {
    document.querySelectorAll('[data-clinic-map]').forEach(map => {
      const frame = map.querySelector('iframe[data-src]');
      const placeholder = map.querySelector('.clinic-booking__map-placeholder');
      if (frame) { frame.removeAttribute('src'); frame.hidden = true; }
      if (placeholder) placeholder.hidden = false;
    });
  }
  function setMaps(allowed) {
    mapsConsent = allowed;
    try {
      if (allowed) localStorage.setItem(storageKey, JSON.stringify({allowed: true, expires: Date.now() + 180 * 86400000}));
      else localStorage.removeItem(storageKey);
    } catch (_) {}
    if (!allowed) unloadMaps();
  }
  function loadMap(map) {
    if (!mapsConsent || !map?.isConnected) return;
    const frame = map.querySelector('iframe[data-src]');
    if (!frame || !/^https:\/\/(www\.)?google\.com\/maps(?:[/?]|$)/.test(frame.dataset.src || '')) return;
    frame.src = frame.dataset.src;
    frame.hidden = false;
    const placeholder = map.querySelector('.clinic-booking__map-placeholder');
    if (placeholder) placeholder.hidden = true;
  }
  function close() {
    dialog.close();
    pendingMap = null;
    returnFocus?.focus();
  }
  async function open(map = null) {
    pendingMap = map;
    returnFocus = document.activeElement;
    status.textContent = '';
    fields.maps.checked = mapsConsent;
    dialog.showModal();
    root.querySelector('[data-privacy-save]').disabled = true;
    try {
      const privacy = await api();
      const consent = privacy.currentVisitorConsent();
      ['analytics', 'marketing', 'preferences'].forEach(purpose => { fields[purpose].checked = consent[purpose] === 'yes'; });
      root.querySelector('[data-privacy-save]').disabled = false;
    } catch (_) { status.textContent = root.dataset.error; }
  }
  async function save(all) {
    if (busy) return;
    busy = true;
    status.textContent = '';
    root.querySelectorAll('[data-privacy-save], [data-privacy-accept], [data-privacy-reject]').forEach(button => { button.disabled = true; });
    const consent = Object.fromEntries(['analytics', 'marketing', 'preferences'].map(purpose => [purpose, typeof all === 'boolean' ? all : fields[purpose].checked]));
    const maps = typeof all === 'boolean' ? all : fields.maps.checked;
    try {
      const privacy = await api();
      await new Promise((resolve, reject) => {
        let timeout, finished = false;
        const matches = () => {
          const saved = privacy.currentVisitorConsent();
          return Object.keys(consent).every(purpose => saved[purpose] === (consent[purpose] ? 'yes' : 'no'));
        };
        const finish = error => {
          if (finished) return;
          finished = true;
          clearTimeout(timeout);
          document.removeEventListener('visitorConsentCollected', collected);
          if (error) reject(error); else resolve();
        };
        const collected = () => { if (matches()) finish(); };
        document.addEventListener('visitorConsentCollected', collected);
        timeout = setTimeout(() => finish(matches() ? null : new Error('privacy timeout')), 10000);
        try {
          privacy.setTrackingConsent(consent, result => finish(result?.error ? new Error('privacy save failed') : null));
        } catch (error) { finish(error); }
      });
      setMaps(maps);
      const map = pendingMap;
      close();
      if (maps && map) loadMap(map);
    } catch (_) { status.textContent = root.dataset.error; }
    finally {
      busy = false;
      root.querySelectorAll('[data-privacy-save], [data-privacy-accept], [data-privacy-reject]').forEach(button => { button.disabled = false; });
    }
  }
  window.clinicPrivacy = {open, openForMap(map) { if (mapsConsent) loadMap(map); else open(map); }};
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (link && new URL(link.href, location.href).hash === '#cookie-einstellungen') {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('#shopify-pc__banner__btn-decline, #shopify-pc__prefs__header-decline')) setMaps(false);
  }, true);
  root.querySelector('[data-privacy-close]').addEventListener('click', close);
  root.querySelector('[data-privacy-save]').addEventListener('click', () => save());
  root.querySelector('[data-privacy-accept]').addEventListener('click', () => save(true));
  root.querySelector('[data-privacy-reject]').addEventListener('click', () => save(false));
  dialog.addEventListener('cancel', () => { pendingMap = null; returnFocus?.focus(); });
  if (location.hash === '#cookie-einstellungen') open();
})();
